import { lazy } from 'react'

export const MenuMetricsLazy = lazy(() => import('./MenuMetrics'))
